import { accountKeys } from "@apis/accounts/queryKeys"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getPossibleAccountTransactions,
  getAccountTransactions,
  assignAccountTransaction,
} from "./accountTransactions"
import { serializeAccountTransactions } from "./serializer"

export const useGetAccountTransactionsQuery = (account_id: string) => {
  return useQuery({
    queryKey: accountKeys.accountTransactions(account_id),
    queryFn: () => getAccountTransactions(account_id),
    select: (data) => serializeAccountTransactions(data),
  })
}

export const useGetPossibleAccountTransactionsQuery = (account_id: string) => {
  return useQuery({
    queryKey: accountKeys.possibleAccountTransactions(account_id),
    queryFn: () => getPossibleAccountTransactions(account_id),
    select: (data) => serializeAccountTransactions(data),
  })
}

export const useAssignAccountTransactionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: assignAccountTransaction,
    onSuccess: (_, { data }) => {
      queryClient.invalidateQueries({
        queryKey: accountKeys.accountTransactions(data.account_id),
      })
      queryClient.invalidateQueries({
        queryKey: accountKeys.possibleAccountTransactions(data.account_id),
      })
    },
  })
}
